import axios from 'axios';
import LearningTimeApp from './learning-time';
import LearningPlanApp from './learning-plan';
import StandardTimeApp from './standard-time';
import UserLearningPlanApp from './user-learning-plan';
import StudyTimer from './study-timer';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

document.addEventListener('DOMContentLoaded', () => {
    // eslint-disable-next-line no-new
    new LearningTimeApp();
    // eslint-disable-next-line no-new
    new LearningPlanApp();
    // eslint-disable-next-line no-new
    new StandardTimeApp();
    // eslint-disable-next-line no-new
    new UserLearningPlanApp();
    // eslint-disable-next-line no-new
    new StudyTimer();
});
